import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';
import SalesforceCloudCheckJson from 'images/SalesforceCloudCheck.json';
export const SalesforceCloudCheck = () => React.createElement(Player, { autoplay: true, keepLastFrame: true, src: SalesforceCloudCheckJson });
